import axios from '@/libraries/axios/main';
import ApiResponseOld from '@/interfaces/ApiResponseOld';
import User from '@/models/User';

export async function fetchUser(id: number): Promise<ApiResponseOld> {
  const response = await axios.get(`/user/show/${id}`);

  return response.data;
}

export async function fetchUsers(): Promise<ApiResponseOld> {
  const response = await axios.get(`/user`);

  return response.data;
}

export async function saveUser(user: User): Promise<ApiResponseOld> {
  const response = await axios.post(`/user/save`, user);

  return response.data;
}

export async function deleteUser(id: string): Promise<{ status: string, message: string }> {
  const response = await axios.delete(`/user/delete/${id}`);

  return response.data as { status: string; message: string };
}
